import React, { useEffect, useState } from 'react'
import { Container, Typography, Accordion, AccordionSummary, AccordionDetails, Box } from '@mui/material'
import { getAllFaqs } from '../services/Apis';



const Faq = () => {
    const [expanded, setExpanded] = React.useState(false);
    const [faqlist, setFaqlist] = useState([])
    const [loading, setLoading] = useState(true);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    useEffect(() => {
        const fetchFaqs = async () => {
            const faqs = await getAllFaqs();
            
             // Simulate loading delay
                
                setFaqlist(faqs);
                setLoading(false);
           // 2 seconds delay
        };
        fetchFaqs();
    }, [])

    return (
        <Container maxWidth="xl" sx={{ py: 4, minHeight: '80vh' }}>
            <Typography variant="h3" fontSize={'24px'} fontWeight={500} mb={3}>
                FAQ's
            </Typography>
           {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 220 }}>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <span className="red-dot" />
                        <span className="red-dot" style={{ animationDelay: '0.2s' }} />
                        <span className="red-dot" style={{ animationDelay: '0.4s' }} />
                    </Box>
                    <style>
                        {`
                        .red-dot {
                            display: inline-block;
                            width: 14px;
                            height: 14px;
                            border-radius: 50%;
                            background: #CB4422;
                            margin: 0 4px;
                            animation: bounce 1s infinite;
                        }
                        @keyframes bounce {
                            0%, 80%, 100% { transform: scale(1); opacity: 1; }
                            40% { transform: scale(1.4); opacity: 0.7; }
                        }
                        `}
                    </style>
                </Box>
            ) :(<Box sx={{ maxWidth: 800, mx: 'auto' }}>
                {faqlist.map((faq, idx) => {
                    const isOpen = expanded === idx;
                    return (
                        <Accordion key={faq.question} expanded={isOpen} onChange={handleChange(idx)}
                            sx={{
                                mb: 2, boxShadow: 'none', borderRadius: 2, bgcolor: isOpen ? '#cb4422' : '#eaeaea',
                                color: isOpen ? '#fff' : '#222',
                                '&:before': { display: 'none' },
                                border: 'none', overflow: 'hidden',
                            }}
                        >
                            <AccordionSummary
                                expandIcon={
                                    <i className={isOpen ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-down fa-rotate-180'}
                                        style={{ color: isOpen ? '#fff' : '#222', fontSize: 20, transform: 'none', transition: 'color 0.2s', }} />
                                }
                                sx={{
                                    fontWeight: 500, fontSize: "16px", fontFamily: 'Poppins', bgcolor: isOpen ? '#cb4422' : '#eaeaea',
                                    color: isOpen ? '#fff' : '#222', minHeight: '40px !important', height: '50px', borderRadius: 2, px: 2,
                                    '& .MuiAccordionSummary-content': { my: 0, minHeight: '40px', height: '40px', alignItems: 'center', },
                                }}
                            >
                                {faq.question}
                            </AccordionSummary>
                            <AccordionDetails
                                sx={{
                                    bgcolor: '#fff',
                                    fontWeight: 400,
                                    fontFamily: 'Poppins',
                                    color: '#434242',
                                    border: isOpen ? '1px solid #cb4422' : 'none',
                                    borderTop: 'none',
                                    borderRadius: '0 0 8px 8px',
                                    fontSize: '14px',
                                    px: 2,
                                    py: 3,
                                }}
                            >
                                <Box
                                    sx={{
                                        p: 0,
                                        '& *': {
                                            padding: 0,
                                            margin: 0,
                                            boxSizing: 'border-box',
                                        },
                                    }}
                                >
                                    <span dangerouslySetInnerHTML={{ __html: faq.answer }} />
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    );
                })}
            </Box>)}
        </Container>
    )
}

export default Faq